import { know_us } from "../../lib/assets";

export const AboutFour = () => {
  return (
    <section className="about-area-four pb-120">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-7 col-md-10 order-0 order-lg-2">
            <div className="about-img-wrap-four">
              <div className="mask-img-wrap">
                <img src={know_us.business_plan} alt="" />
              </div>
              <div className="icon">
                <i className="flaticon-business-presentation"></i>
              </div>
              <img src={know_us.business_goal} alt="" className="img-two" />
              <div className="about-shape-wrap-three">
                <img src={know_us.ribbon_shape} alt="" />
                <img src={know_us.grid_shape} alt="" />
                <img src={know_us.star} alt="" width={50} />
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="about-content-four">
              <div className="section-title-two mb-30 tg-heading-subheading animation-style1">
                <span className="sub-title tg-element-title">
                  Get To know US
                </span>
                <h2 className="title tg-element-title">
                  We are the next gen Business experience
                </h2>
              </div>
              <p>
                Kadle Global Pvt Ltd is a leading innovator driving growth
                through Technology, Infrastructure, Agriculture, and Renewable
                Energy sectors. Focused on sustainable development and
                cutting-edge solutions, we empower industries and communities
                with future-ready services tailored for the modern world.
              </p>
              <div className="about-list-three">
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <i className="flaticon-mission"></i>
                    </div>
                    <div className="content">
                      <h2 className="title">Technology services</h2>
                      <p>
                        Kadle Global Pvt Ltd offers expert technology,
                        infrastructure, agriculture, and renewable energy
                        services.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="flaticon-profit"></i>
                    </div>
                    <div className="content">
                      <h2 className="title">Innovation</h2>
                      <p>Driving sustainable growth with innovation.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
